import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'musteri-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="me-edit">
      <div class="me-baslik">
        <div class="me-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 17v-2a4 4 0 014-4h2"/><circle cx="12" cy="7" r="2"/>
          </svg>
        </div>
        <span>Müşteri Bilgileri</span>
      </div>

      <div class="me-form">
        <div class="logo-alan">
          <div class="logo-onizleme">
            @if (logoOnizleme()) {
              <img [src]="logoOnizleme()" class="logo-img" (error)="guncelle('_logoBase64', '')" />
            } @else {
              <div class="logo-placeholder">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
              </div>
            }
          </div>
          <div class="logo-islemler">
            <label class="logo-sec-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
              Logo Yükle
              <input type="file" accept="image/*" (change)="logoSec($event)" hidden />
            </label>
            @if (p()?.logoUrl || p()?._logoBase64) {
              <button type="button" class="logo-sil-btn" (click)="guncelle('logoUrl', ''); guncelle('_logoBase64', '')">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                Kaldır
              </button>
            }
          </div>
        </div>

        <div class="form-grup">
          <label>Firma Adı <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.firmaAdi || ''"
              (ngModelChange)="guncelle('firmaAdi', $event)"
              placeholder="Firma adını girin..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Yetkili Kişi</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.yetkiliKisi || ''"
              (ngModelChange)="guncelle('yetkiliKisi', $event)"
              placeholder="Yetkili kişi adı..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="me-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup flex-1">
            <label>Telefon</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                [ngModel]="p()?.telefon || ''"
                (ngModelChange)="guncelle('telefon', $event)"
                placeholder="0(5XX) XXX XX XX"/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup flex-1">
            <label>E-posta</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                [ngModel]="p()?.eposta || ''"
                (ngModelChange)="guncelle('eposta', $event)"
                placeholder="ornek@firma.com"/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="form-grup">
          <label>Adres</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.adres || ''"
              (ngModelChange)="guncelle('adres', $event)"
              placeholder="Firma adresi..."
              cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="3">
            </textarea>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="me-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup flex-1">
            <label>Vergi No</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
                [ngModel]="p()?.vergiNo || ''"
                (ngModelChange)="guncelle('vergiNo', $event)"
                placeholder="Vergi numarası"/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup flex-1">
            <label>Sektör</label>
            <div class="input-wrap">
              <nz-select
                [ngModel]="p()?.sektor"
                (ngModelChange)="guncelle('sektor', $event)"
                nzPlaceHolder="Sektör seçin..."
                nzAllowClear
                style="width:100%"
                [nzCustomTemplate]="sektorTpl">
                <nz-option nzValue="Otomotiv" nzLabel="Otomotiv" nzCustomContent>
                  <div class="sel-item"><span class="sel-dot" style="background:#3b82f6"></span><span class="sel-ad">Otomotiv</span></div>
                </nz-option>
                <nz-option nzValue="Makine" nzLabel="Makine" nzCustomContent>
                  <div class="sel-item"><span class="sel-dot" style="background:#f59e0b"></span><span class="sel-ad">Makine</span></div>
                </nz-option>
                <nz-option nzValue="İnşaat" nzLabel="İnşaat" nzCustomContent>
                  <div class="sel-item"><span class="sel-dot" style="background:#ef4444"></span><span class="sel-ad">İnşaat</span></div>
                </nz-option>
                <nz-option nzValue="Enerji" nzLabel="Enerji" nzCustomContent>
                  <div class="sel-item"><span class="sel-dot" style="background:#22c55e"></span><span class="sel-ad">Enerji</span></div>
                </nz-option>
                <nz-option nzValue="Savunma" nzLabel="Savunma" nzCustomContent>
                  <div class="sel-item"><span class="sel-dot" style="background:#6366f1"></span><span class="sel-ad">Savunma</span></div>
                </nz-option>
                <nz-option nzValue="Gıda" nzLabel="Gıda" nzCustomContent>
                  <div class="sel-item"><span class="sel-dot" style="background:#ec4899"></span><span class="sel-ad">Gıda</span></div>
                </nz-option>
                <nz-option nzValue="Diğer" nzLabel="Diğer" nzCustomContent>
                  <div class="sel-item"><span class="sel-dot" style="background:#6b7280"></span><span class="sel-ad">Diğer</span></div>
                </nz-option>
              </nz-select>
              <ng-template #sektorTpl let-selected>
                <span class="sel-item"><span class="sel-dot" [style.background]="sektorRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
              </ng-template>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="me-ayirici"></div>

        <div class="form-grup">
          <label>Notlar</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.notlar || ''"
              (ngModelChange)="guncelle('notlar', $event)"
              placeholder="Müşteri hakkında notlar..."
              cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4">
            </textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }

    .me-edit {
      display: flex;
      flex-direction: column;
      gap: 0;
      padding: 0;
    }

    .me-baslik {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 16px;
      margin-bottom: 4px;
      border-radius: 10px;
      background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent);
    }

    .me-baslik-ikon {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #0d9488, #14b8a6);
      color: #fff;
      flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(13, 148, 136, 0.35);
      position: relative;
    }

    .me-baslik-ikon::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%);
      background-size: 200% 100%;
      animation: shimmer 3s infinite linear;
      pointer-events: none;
    }

    .me-baslik span {
      font-size: 13px;
      font-weight: 600;
      color: var(--py-metin, #333);
      letter-spacing: 0.3px;
    }

    .me-form {
      display: flex;
      flex-direction: column;
      gap: 14px;
      padding: 4px 2px;
    }

    .me-ayirici {
      height: 1px;
      background: linear-gradient(90deg, transparent, var(--py-kenarlik, #d9d9d9) 20%, var(--py-kenarlik, #d9d9d9) 80%, transparent);
      opacity: 0.4;
      margin: 2px 0;
    }

    .form-satir {
      display: flex;
      gap: 12px;
    }

    .flex-1 { flex: 1; }

    .form-grup {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .form-grup label {
      font-size: 11px;
      font-weight: 500;
      color: var(--py-metin-ucuncul, rgba(0,0,0,0.45));
      text-transform: uppercase;
      letter-spacing: 0.6px;
      padding-left: 2px;
      transition: color 0.2s ease;
    }

    .form-grup:focus-within label {
      color: var(--py-link, #1890ff);
    }

    .zorunlu {
      color: #ff4d4f;
      font-size: 13px;
      line-height: 1;
      vertical-align: middle;
    }

    .input-wrap { position: relative; }

    .input-glow {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 2px;
      border-radius: 1px;
      background: linear-gradient(90deg, #0d9488, #14b8a6, #0d9488);
      transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), left 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
      opacity: 0;
      pointer-events: none;
      z-index: 1;
    }

    .input-wrap:focus-within .input-glow {
      width: 100%;
      left: 0;
      opacity: 1;
    }

    .input-wrap input[nz-input],
    .input-wrap textarea[nz-input] {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      border: 1px solid var(--py-kenarlik, #d9d9d9);
      border-radius: 8px;
      padding: 7px 11px;
      font-size: 13px;
      color: var(--py-metin, #333);
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap input[nz-input]:hover,
    .input-wrap textarea[nz-input]:hover {
      border-color: var(--py-kenarlik-hover, #b3b3b3);
      background: var(--py-arkaplan-hover, #f5f5f5);
    }

    .input-wrap input[nz-input]:focus,
    .input-wrap textarea[nz-input]:focus {
      border-color: var(--py-kenarlik-aktif, #1890ff);
      background: var(--py-input-arka, #fff);
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
      outline: none;
    }

    .input-wrap ::ng-deep .ant-select-selector {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important;
      border-radius: 8px !important;
      min-height: 34px;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap:hover ::ng-deep .ant-select-selector {
      border-color: var(--py-kenarlik-hover, #b3b3b3) !important;
      background: var(--py-arkaplan-hover, #f5f5f5) !important;
    }

    .input-wrap:focus-within ::ng-deep .ant-select-selector {
      border-color: var(--py-kenarlik-aktif, #1890ff) !important;
      background: var(--py-input-arka, #fff) !important;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important;
    }

    .logo-alan { display: flex; align-items: center; gap: 16px; padding: 12px 0; margin-bottom: 8px; }
    .logo-onizleme { width: 72px; height: 72px; border-radius: 12px; overflow: hidden; flex-shrink: 0; border: 2px dashed var(--py-kenarlik, #d9d9d9); display: flex; align-items: center; justify-content: center; background: var(--py-arkaplan-soluk, rgba(0,0,0,.02)); transition: border-color .2s; }
    .logo-onizleme:hover { border-color: var(--py-link, #1890ff); }
    .logo-img { width: 100%; height: 100%; object-fit: contain; }
    .logo-placeholder { color: var(--py-metin-devre-disi, #bbb); }
    .logo-islemler { display: flex; flex-direction: column; gap: 6px; }
    .logo-sec-btn { display: inline-flex; align-items: center; gap: 6px; cursor: pointer; padding: 5px 12px; border-radius: 6px; font-size: 12px; font-weight: 500; background: linear-gradient(135deg, rgba(20,184,166,.1), rgba(20,184,166,.05)); color: #14b8a6; border: 1px solid rgba(20,184,166,.2); transition: all .2s; }
    .logo-sec-btn:hover { background: rgba(20,184,166,.15); }
    .logo-sil-btn { display: inline-flex; align-items: center; gap: 4px; cursor: pointer; padding: 4px 10px; border-radius: 6px; font-size: 11px; background: transparent; color: #ef4444; border: 1px solid rgba(239,68,68,.2); transition: all .2s; }
    .logo-sil-btn:hover { background: rgba(239,68,68,.08); }

    @keyframes shimmer {
      0% { background-position: -200% center; }
      100% { background-position: 200% center; }
    }
  `],
})
export class MusteriEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();

  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});

  sektorRenk(v: string): string {
    const m: Record<string, string> = { 'Otomotiv': '#3b82f6', 'Makine': '#f59e0b', 'İnşaat': '#ef4444', 'Enerji': '#22c55e', 'Savunma': '#6366f1', 'Gıda': '#ec4899', 'Diğer': '#6b7280' };
    return m[v] || '#6b7280';
  }

  logoOnizleme = computed(() => {
    const ek = this.p();
    return ek?._logoBase64 || ek?.logoUrl || '';
  });

  logoSec(event: Event) {
    const input = event.target as HTMLInputElement;
    const dosya = input?.files?.[0];
    if (!dosya) return;
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      this.guncelle('logoUrl', base64);
      this.guncelle('_logoBase64', base64);
    };
    reader.readAsDataURL(dosya);
  }

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) {
      params.ek[alan] = deger;
      this.parametreler.set({ ...params });
    }
  }
}
